import { ProviderConsumer as FluentUIThemeConsumer } from '@fluentui/react-northstar';
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { AppStateContext, appState } from "../../../../AppState";
import { platformService } from '../../../services/platform.service';
import { NewAttachmentFlowContent } from "./NewAttachmentFlowContent";

export const NewAttachmentTemplateFlowPage: React.FC = () => {
    const api = new platformService();
    const { ticketId, templateId, isEndUserPage } = useParams<any>();
    const query = new URLSearchParams(useLocation().search);
    const token = query.get('data');
    const currentState = appState();
    const [isLoading, setIsLoading] = useState(true);
    const [templateData, setTemplateData] = useState('');
    const isEndUser = (isEndUserPage?.toLowerCase() ?? "false") === "true";

    useEffect(() => {
        const getData = async () => {
            const result = await api.getTeamsPayload(token);
            setTemplateData(result.data.value);
            setIsLoading(false);
        };
        getData();
    }, []);
    
    return (
        <AppStateContext.Consumer>
      {(state) => {
        return (
            <FluentUIThemeConsumer
        render={globalTheme => (
            <div className={`h-screen px-10 py-2`}>
                {!isLoading && <NewAttachmentFlowContent globalTheme={globalTheme} ticketId={ticketId} filesToUpload={[]} onInteraction={() => {}} teamsConfig={currentState.teamsConfig} isEndUserPage={isEndUser} uploadFromCustomFormProps={{fromTemplate: true, templateData: templateData, templateId: templateId}}/>}
            </div>
        )} />
        );
      }}    
    </AppStateContext.Consumer>)
}